export default __webpack_public_path__ + "static/N0320-ca4204f97afbe3b82f00ef1a848ce014.png";